import type { ProspectState } from '../types';

interface StateBadgeProps {
  state: ProspectState;
}

const STATE_CONFIG: Record<ProspectState, { label: string; bg: string; text: string }> = {
  DISCOVERED: { label: 'Discovered', bg: '#e0e7ff', text: '#3730a3' },
  FILTERED_OUT: { label: 'Filtered Out', bg: '#f3f4f6', text: '#6b7280' },
  QUALIFIED: { label: 'Qualified', bg: '#dbeafe', text: '#1e40af' },
  CONTACT_FOUND: { label: 'Contact Found', bg: '#ede9fe', text: '#5b21b6' },
  CONTACT_VERIFIED: { label: 'Verified', bg: '#d8b4fe', text: '#4c1d95' },
  DRAFT_READY: { label: 'Draft Ready', bg: '#fef9c3', text: '#854d0e' },
  AWAITING_APPROVAL: { label: 'Awaiting Approval', bg: '#fed7aa', text: '#9a3412' },
  APPROVED: { label: 'Approved', bg: '#bbf7d0', text: '#14532d' },
  SENT: { label: 'Sent', bg: '#d1fae5', text: '#065f46' },
  REPLIED: { label: 'Replied', bg: '#bfdbfe', text: '#1e3a8a' },
  BOUNCED: { label: 'Bounced', bg: '#fee2e2', text: '#991b1b' },
  SUPPRESSED: { label: 'Suppressed', bg: '#fce7f3', text: '#831843' },
  HIGH_INTENT: { label: '🔥 High Intent', bg: '#fff7ed', text: '#7c2d12' },
};

export function StateBadge({ state }: StateBadgeProps) {
  const config = STATE_CONFIG[state] ?? {
    label: state,
    bg: '#f3f4f6',
    text: '#374151',
  };

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '2px 8px',
        borderRadius: '9999px',
        fontSize: '12px',
        fontWeight: 600,
        backgroundColor: config.bg,
        color: config.text,
        whiteSpace: 'nowrap',
      }}
    >
      {config.label}
    </span>
  );
}
